<template>
    <!-- Shipping template -->
    <div style="border-bottom: 1px dotted #ccc; margin-bottom: 50px; padding-bottom: 30px;">
        <div class="row">
            <div class="col-md-10">
                <h2>1. Delivery method</h2>
            </div>
            <div class="col-md-2 text-right">
                <a href="javascript:void(0);" v-on:click="turnOnEditMode">Edit</a>
            </div>
        </div>
        <div v-show="Cart.Dealer">
            <p>
                <strong>{{Cart.ShippingName}}</strong>
            </p>
            <p>{{stock?.Label}} at {{Cart.Dealer?.Name}} ({{Cart.Dealer?.DistanceToFormat}} miles)</p>
        </div>
        <div v-show="Cart.Dealer == null">
            <p>
                <strong>{{Cart.ShippingName}}</strong>
            </p>
            <p>{{Order.Street}}<br/>{{Order.Postalcode}} {{Order.City}}</p>
        </div>
    </div>
</template>
<script>
    import vueStore from '../store/store.js';
    import cartMixin from '../mixins/cart-mixin.js';
    import generalMixin from '../mixins/general.js';
    export default {
        name: 'shipping',
        mixins: [cartMixin, generalMixin],
        props: ['editMode'],
        template: '#shipping',
        data: function () {
            return {
            }
        },
        methods: {
            turnOnEditMode() {

            }
        },
        computed: {
            shippingOption: {
                get() {
                    return this.Cart.ShippingOptions?.filter(x => x.Guid == this.Cart.ShippingGuid);
                }
            },
            stock: {
                get() {
                    if (this.Cart && this.Cart.CartItems != null && this.Cart.CartItems.length > 0) {
                        return this.Cart.CartItems[0].Stock;
                    }
                    return null;
                }
            },
            Order: {
                get() {
                    if (vueStore.state && vueStore.state.cart && vueStore.state.cart.Order) {
                        return vueStore.state.cart.Order;
                    } else {
                        return {};
                    }
                }
            }
        },
        created() {
            //this.interfaceTexts = JSON.parse(document.getElementById('vue-checkout').dataset.interfacetexts);
        }
    }
</script>
